var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.handleClickOutside,
          expression: "handleClickOutside",
        },
      ],
      staticClass: "profile-actions-menu mt-2",
    },
    [
      _c(
        "a",
        { staticClass: "d-flex clickable small no-bg-hover no-bg-active" },
        [
          _c(
            "div",
            {
              ref: "colorPicker",
              staticClass:
                "client-profile-colour input-group colorpicker-component",
            },
            [_c("span", { staticClass: "input-group-append" })]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "d-flex clickable small add-note-follow-up",
          on: { click: _vm.showAddActivityNoteModal },
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("boards.actions.addActivityNote")) + "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "d-flex clickable transfer-to-board small",
          on: { click: _vm.showTransferClientModal },
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$tc("boards.actions.moveClient", 1)) + "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c("inline-prompt", {
        ref: "prompt",
        staticClass: "bold text-grey",
        attrs: {
          "action-text": _vm.movingToInactive
            ? _vm.$t("boards.messages.movingToInactive") + "..."
            : _vm.$t("boards.actions.markAsInactive"),
          "action-class-text": _vm.markInactiveClass,
          "action-type": "delete",
          "confirmation-text": _vm.$t(
            "boards.messages.markAsInactiveConfirmation"
          ),
        },
        on: { accept: _vm.handleMarkAsInactive },
      }),
      _vm._v(" "),
      _c("transfer-client-profile-modal", {
        ref: "transferClientProfileModal",
        attrs: {
          boards: _vm.boardsWithoutCurrent,
          "client-profile-id": _vm.clientProfileId,
          "client-profile-name": _vm.clientProfileName,
          "status-label-id": _vm.statusLabelId,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }